import Vue from "vue";

import Toast from "mand-mobile/lib/toast/index";
Vue.component(Toast.name, Toast);
Vue.component(Toast.component.name, Toast.component);
Vue.prototype.$toast = Toast;

import Swiper from "mand-mobile/lib/swiper/index";
Vue.component(Swiper.name, Swiper);

import SwiperItem from "mand-mobile/lib/swiper-item/index";
Vue.component(SwiperItem.name, SwiperItem);

import { Tabs, TabPane } from "mand-mobile";
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);
